export default "__VITE_ASSET__BTOtUdJH__"